export default __webpack_public_path__ + "static/media/Delasoft.fb4a1182.png";